module.exports = function() {
  if (this.options.debug && console) {
    if (typeof console.log === "function") {
      console.log.apply(console, arguments);
    }
    // IE is weird
    else if (console.log) {
      console.log(arguments);
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/pjax/lib/proto/log.js
// module id = 54
// module chunks = 0